export default {
    SET_INSTALLATION_STATUS(state, event) {
        state.pwaPromptInstall = event;
    },

    IS_PWA(state, value) {
        state.isPWA = value
    }
}